import { Spin } from "antd";

export const LoadingOverlay = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Spin size="large" />
    </div>
  );
};
